export default {
  computed: {
    descriptorsAdditionalData() {
      return {
        // boolean: {
        //   descriptors: {
        //     false: {
        //       dataType: { name: 'text' },
        //     },
        //     true: {
        //       dataType: { name: 'text' },
        //     },
        //   },
        //   alert: '',
        // },
        decimal: {
          descriptors: {
            max_digits: {
              dataType: { name: 'integer' },
              straightTitle: this.$i18n.t('admin.descriptors.decimal.maxDigits'),
              subtitle: 'admin.descriptors.decimal.maxDigitsSubtitle',
              minValue: 1,
              allowNegative: false,
            },
            decimal_places: {
              dataType: { name: 'integer' },
              straightTitle: this.$i18n.t('admin.descriptors.decimal.decimalPlaces'),
              subtitle: 'admin.descriptors.decimal.decimalPlacesSubtitle',
              minValue: 1,
              allowNegative: false,
            },
          },
          alert: this.$i18n.t('admin.descriptors.decimal.alert'),
        },
        // text: {
        //   descriptors: {
        //     max_length: {
        //       dataType: { name: 'integer' },
        //       minValue: 1,
        //       allowNegative: false,
        //     },
        //   },
        //   alert: '',
        // },
      };
    },
  },
};
